import { render } from "./ImportWallet.vue?vue&type=template&id=c0e774b2&scoped=true"
import script from "./ImportWallet.vue?vue&type=script&lang=js"
export * from "./ImportWallet.vue?vue&type=script&lang=js"

import "./ImportWallet.vue?vue&type=style&index=0&id=c0e774b2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e774b2"]])

export default __exports__